export default __webpack_public_path__ + "static/media/bb.f1866cb5.svg";